/**
 * Error404Ctrl controller
 * Page 404 controller
 */

/**
 * Error404Ctrl controller
 *
 * @class Error404Ctrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:Error404Ctrl
 */
/* @ngInject */
export default function Error404Ctrl ($stateParams) {
  var vm = this
  vm.message = $stateParams.message
}
